import { Textarea, TextareaProps } from '@primer/react';
import { useLayoutEffect, useRef, useState } from 'react';
import { useCommonContext } from '../../../contexts/common';
import useAutosizeTextArea from '../../../hooks/useAutosizeTextArea';

interface ITextAreaAutoHeightProps extends TextareaProps {
    register?: any,
    errors?: any,
    validateMessage?: string,
    name?: string,
    required?: boolean,
    minLength?: number,
    maxLength?: number,
    isAutoFocus?: boolean,
    onValueChanged?: (value: string) => void
}
const TextAreaAutoHeight = (props: ITextAreaAutoHeightProps) => {
    const { register, errors } = props;
    const { translate } = useCommonContext();
    const [value, setValue] = useState("");
    const textAreaRef = useRef<HTMLTextAreaElement>(null);
    useAutosizeTextArea(textAreaRef.current, value);
    useLayoutEffect(() => {
        if (props.value !== undefined && props.value !== null) {
            setValue(props.value.toString())
        } else if (props.defaultValue !== undefined && props.defaultValue !== null) {
            setValue(props.defaultValue.toString())
        }
        if (props.isAutoFocus) {
            textAreaRef.current?.focus()
        }
    }, [props.value, props.defaultValue, props.isAutoFocus])
    const handleChange = (evt: React.ChangeEvent<HTMLTextAreaElement>) => {
        const val = evt.target?.value;
        setValue(val);
        if (props.onValueChanged) props.onValueChanged(val);
    };
    return (
        <>
            <Textarea
                {
                ...props
                }
                sx={props.sx}
                rows={1}
                defaultValue={props.defaultValue}
                ref={textAreaRef}
                onChange={handleChange}
                onBlur={(e) => {
                    if (props.onValueChanged) props.onValueChanged(e.target.value);
                    if (props.onBlur) props.onBlur(e);
                }}

            />
        </>
    );
};

export default TextAreaAutoHeight;